<div>
  @if (!type) {
    <input
      #messageInput
      [id]="inputID ? inputID : ''"
      (blur)="blur.next(true)"
      [type]="type"
      [class]="class"
      [placeholder]="placeholder"
      [(ngModel)]="message"
      (keydown)="keyDownEvent($event)"
      (keyup)="keyUpEvent($event)"
      (paste)="contentPasted($event)"
    />
  }
  @if (type == "textarea") {
    <textarea #messageInput [id]="inputID ? inputID : null" [class]="class" [placeholder]="placeholder" [(ngModel)]="message" (keydown)="keyDownEvent($event)" (keyup)="keyUpEvent($event)"></textarea>
  }

  @if (type == "span") {
    <div
      #container
      class="editable-message-span-container"
      [class.include-border-top]="backgroundColor == 'transparent'"
      [ngStyle]="{ 'background-color': backgroundColor, 'border-radius': backgroundColor != 'transparent' ? '10px' : '0px' }"
    >
      @if (!useQuill) {
        <span
          id="comment"
          role="textbox"
          [attr.aria-label]="ariaLabelBy ? null : 'message'"
          [attr.aria-labelledby]="ariaLabelBy ? ariaLabelBy : null"
          [attr.aria-describedby]="ariaDescribedBy ? ariaDescribedBy : null"
          #messageSpan
          [id]="inputID ? inputID : 'input_span'"
          class="editable-message-span"
          (keyup)="keyUpEvent($event)"
          (keydown)="keyDownEvent($event)"
          (input)="inputEvent()"
          (click)="editorClicked()"
          (paste)="contentPasted($event)"
          (focusin)="focusIn($event)"
          (focusout)="focusOut($event)"
          contenteditable
          [attr.aria-expanded]="mentionSource ? (elligibleMentions.length ? 'true' : 'false') : null"
          [attr.aria-autocomplete]="mentionSource ? 'list' : null"
          [attr.aria-activedescendant]="activeMentionOptionId"
          [innerText]=""
          [attr.data-placeholder]="placeholder"
        ></span>
      }
      @if (useQuill) {
        <div class="w-full quill-container">
          <div [id]="'qe_' + inputID"></div>
          <div [id]="'qt_' + inputID"></div>
        </div>
      }
      <div class="d-flex send-btn-container">
        @if (includeAttachmentButton) {
          <img
            src="./assets/icons/workspace-upload.png"
            (click)="attachmentBtnClicked.next(true)"
            class="attach-btn in-input"
            placement="top"
            container="body"
            [ngbTooltip]="'sphere.workspaces.share_file' | translate"
          />
        }
        @if (includeSendButton && !textSendButton) {
          <button type="button" class="p-0" (click)="send()" (keyup.enter)="send()" aria-label="send">
            @if (!sendButtonLoading) {
              <fa-icon icon="arrow-alt-circle-up" class="send-icon" aria-hidden="true"></fa-icon>
            }
            @if (sendButtonLoading) {
              <fa-icon icon="spinner" animation="spin" class="send-icon" aria-hidden="true"></fa-icon>
            }
            <span class="sr-only">send</span>
          </button>
        }
        @if (textSendButton) {
          <button type="button" class="btn btn-secondary" (click)="send()" (keyup.enter)="send()" aria-label="send">
            @if (!sendButtonLoading) {
              Send
            }
            @if (sendButtonLoading) {
              <fa-icon icon="spinner" animation="spin" class="send-icon" aria-hidden="true"></fa-icon>
            }
            <span class="sr-only">send</span>
          </button>
        }
      </div>
    </div>
  }
  <!--
    The mention picker is no longer rendered here. It lives in a CDK overlay
    attached to <body> (see MentionOverlayController) so it can float over the
    `overflow: hidden` containers that used to clip it in the workspace and
    file-detail chats.
  -->
  <span class="sr-only" aria-live="polite">
    @if (elligibleMentions.length) {
      {{ elligibleMentions.length }} people available. Use arrow keys to choose, enter to select.
    }
  </span>
</div>
